import React from 'react';
import { Button, Table, Glyphicon, Row, Col } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { Auto } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'
import * as API from 'modules/app/API'
import * as App from 'modules/app/App'

class RoleUsersTab extends SetupTab {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialForm = () => {
        return {
            userId: null,
            fullName: "",
            roleUsers: []
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminUserSetupAdd"),
            edit: App.hasPrivilege("AdminUserSetupEdit"),
            delete: App.hasPrivilege("AdminUserSetupDelete")
        }
    }

    urls() {
        return {
            get: API.Security.url('/roleSetup/getRoleUsers')
        }
    }

    getRequest(selectedId) {
        return {
            roleId: selectedId
        }
    }

    usersLoader = () => {
        return {
            url: API.Security.url('/lookup/lookupUser')
        }
    }

    handleDeleteUserFromRole(userId, fullName) {
        Modals.confirm("Are you sure you wish to remove '" + fullName + "' from the '" + this.state.title + "' role?", () => {
            API.Security.post('/roleSetup/deleteRoleUser', {
                userId: userId,
                roleId: this.props.selectedId
            },
                {
                    success: (r) => {
                        this.setState((prevState) => {
                            return {
                                form: Object.assign(prevState.form, {
                                    roleUsers: prevState.form.roleUsers.filter((item) => {
                                        return item.userId !== userId;
                                    })
                                })
                            }
                        });

                        this.props.onSuccess(r.message);
                    },
                    error: (r) => {
                        this.props.onError(r.error);
                    }
                });
        });
    }

    handleAddUserToRole = () => {
        API.Security.post('/roleSetup/addRoleUser', {
            userId: this.state.form.userId,
            roleId: this.props.selectedId
        },
            {
                success: (r) => {
                    this.setState({
                        form: {
                            ...this.state.form,
                            roleUser: this.state.form.roleUsers.push(r.data.roleUser)
                        }
                    })

                    this.props.onSuccess(r.message);
                    this.props.onSetWarnOnBack(false);
                },
                error: (r) => {
                    this.props.onError(r.error);
                }
            });
    }

    isDirty = () => {
        // Added for compatibility with SetupTabView
    }

    renderButtons = () => {
        return (
            <div>
                {
                    this.state.privileges.add && this.state.privileges.edit &&
                    <div>
                        <hr />
                        <Row>
                            <Col md={3}>
                                <Auto
                                    name="userId"
                                    placeholder="Select User"
                                    label="fullName"
                                    loader={this.usersLoader}
                                    menuPlacement="top" />
                            </Col>
                            <Col md={3}>
                                <Button id="btnAddUserToRole" bsStyle="success" onClick={this.handleAddUserToRole} disabled={!this.state.form.userId}>Add user to role</Button>
                            </Col>
                        </Row>
                    </div>
                }
            </div>
        );
    }

    renderForm() {
        const me = this;
        const rows = this.state.form.roleUsers.map(function (item) {
            return (
                <tr key={item.userId}>
                    <td className="col-md-2">{item.fullName}</td>
                    <td className="col-md-4">{item.email}</td>
                    <td className="cold-md-1 text-right">
                        <Button onClick={() => me.handleDeleteUserFromRole(item.userId, item.fullName)} bsSize="xsmall"><Glyphicon glyph="remove" /></Button>
                    </td>
                </tr>
            );
        });

        return (
            <Table>
                <thead>
                    <tr>
                        <th className="col-md-2">User Name</th>
                        <th className="col-md-4">Email</th>
                        <th className="col-md-1 text-right"></th>
                    </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </Table>
		);
    }
}

export default RoleUsersTab;



// WEBPACK FOOTER //
// ./src/areas/admin/roleSetup/roleUsers/RoleUsersTab.js